import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import './tabs-content.scss';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, } from 'recharts';
import { Grid } from '@mui/material';
// import LineGraph from './LineGraph';

const PlacementProcess = () => {
    return (
        <div className='Placement-process'>
            <ul>
                <li>Every year the enrollment process for placements begins when students come to pre final year.</li>
                <li>Each department will have one faculty and two student coordinators to facilitate training and placement activities.</li>
                <li>The coordinators organize mock test and group discussion in their respective classes. External trainers are invited to train the students on solving the aptitude, prepare for group discussion, interview facing skills and technical skills. Experts from the varied industries are invited to give guest lecture on the latest technologies.</li>
                <li>Every year more than three hundred reputed companies are invited to visit our institution to recruit our students for internship and full time jobs.</li>
                <li>Several companies send their assessment form to assess our institute before they visit for recruitment. We provide all the required information to the companies. Based on the information provided, companies visit our institution for campus recruitment.</li>
                <li>More than one hundred and twenty companies from different sectors visit BIT to recruit students for internship and full-time job. More than five hundred students get their dream jobs through placement center.</li>
            </ul>
        </div>
    )
}


function PlacementStatistics(){
  const data=[
    {
     "year": 2015,
     "companies":81,
     "offers":663,
     
    },
    {
      "year": 2016,
      "companies":83,
      "offers":591,
     },
     {
      "year": 2017,
      "companies":102,
      "offers":561,
     },
     {
      "year": 2018,
      "companies":89,
      "offers":561,
     },
     {
      "year": 2019,
      "companies":145,
      "offers":662,
     },
     {
      "year": 2020,
      "companies":112,
      "offers":591,
     },
     {
      "year": 2021,
      "companies":145,
      "offers":608,
     },
     {
      "year": 2022,
      "companies":70,
      "offers":840,
     },
     
  ]
 return (
    <div>
    {/* <LineGraph /> */}
    <Grid item width="100%" height="100%" align='center'>
 <AreaChart width={730} height={250} data={data}
  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="year" />
  <YAxis />
  <Tooltip />
  <Legend />
  <Area type="monotone" dataKey="companies" stroke="#8884d8" fillOpacity={0.1} fill="#8884d8"/>
  </AreaChart>  
<AreaChart width={730} height={250} data={data}
  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="year" />
  <YAxis />
  <Tooltip />
  <Legend />
  <Area type="monotone" dataKey="offers" stroke="#82ca9d" fillOpacity={0.1} fill="#82ca9d"/>
</AreaChart>
  </Grid>

    <div>
    <br></br>
    <h1>Companies visited during:</h1>
      <ul>
            <li> <a href='https://bit-bangalore.edu.in/wp-content/uploads/2021/12/COMPANY-VISITED-2022.pdf'> 2022</a></li>
            <li><a href='https://bit-bangalore.edu.in/wp-content/uploads/2021/07/Companies-during-2021.pdf'> 2021</a></li>
        </ul>
       </div> 
</div>
    
 )


}

const OurRecruiters = () => {
    return (
        <div>
            <img className='Recruiters-img' src='https://bit-bangalore.edu.in/wp-content/uploads/2019/09/our-recruiters.jpg' alt='recruiters'></img>
        </div>
    )
}

const ActivitiesFacilities = () => {
    return (
        <div>
        <div className='Activities'>
        <h1>Activities conducted by Department of Training & Placement Cell</h1>
            <Carousel>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/Pre-Placement-Talk-of-Infosys.jpg"
      alt="First slide"
      style={{height:500, width:500}}
    />
    <Carousel.Caption>
      <h3>Pre-Placement Talk of Infosys</h3>
      {/* <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/Pre-Placement-Talk-of-DXC-.jpg"
      alt="Second slide"
      style={{height:500, width:500}}
    />

    <Carousel.Caption>
      <h3>Pre-Placement Talk of DXC</h3>
      {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/MOU-with-IRSC-ROBERT-BOSCH-.jpg"
      alt="Third slide"
      style={{height:500, width:200}}
    />

    <Carousel.Caption>
      <h3>MOU with IRSC & ROBERT BOSCH</h3>
      {/* <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
    </Carousel.Caption>
    
  </Carousel.Item>
</Carousel>
</div>
<div className='facilities'>
<h1>Facilities</h1>
<Carousel>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/Facilities.jpg"
      alt="First slide"
      style={{height:500, width:200}}
    />
    <Carousel.Caption>
      <h3>Placement Office</h3>
      
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/Seminar-Hall1.jpg"
      alt="Second slide"
      style={{height:500, width:200}}
    />

    <Carousel.Caption>
      <h3>Seminar Hall</h3>
      
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/GD2.jpg"
      alt="Third slide"
      style={{height:500, width:200}}
    />

    <Carousel.Caption>
      <h3>Group Discussion Rooms</h3>
      
    </Carousel.Caption>
    
  </Carousel.Item>
</Carousel>
</div>
        </div>
    )
}

const PlacementTeam = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      const Slide=({Source,Name,Designation,Designation2})=>{
        return(
            <div style={{display:'flex', alignItems:'center',flexDirection:'column'}}>
            <img src={Source} alt='faculty' style={{width:120, height:120}}></img>
            <p><b>{Name}</b></p>
            <p><i>{Designation}</i></p>
            <p><i>{Designation2}</i></p>
            </div>
        )
      }




    return (
        
        <div>
            
           
            <div style={{justifyContent:"center", padding:"10%"}}>
            <div>
            <h1>Placement Team</h1>
            <br></br>
            <Slider {...settings}>
            <Slide 
            Source='https://bit-bangalore.edu.in/wp-content/uploads/2019/02/f1.jpg'
            Name='Dr. Aswath M. U'
            Designation='Principal'
            Designation2='Advisor ,Training & Placement'
               
            />
            <Slide 
            Source='https://bit-bangalore.edu.in/wp-content/uploads/2019/02/m9.jpg'
            Name='Dr. Reddappa H.N.'
            Designation='Placement Officer'
            />
            </Slider>
            </div>
            <div>
            <br></br>
            <h1>Faculty Placement Coordinators</h1>
            <br></br>
            <Slider {...settings}>
            <Slide 
                Source='https://bit-bangalore.edu.in/wp-content/uploads/2020/10/Gangadhar.jpg'
            Name='Prof. S. Gangadhar'
            Designation='Civil Engineering'
            />
            <Slide 
                Source='https://bit-bangalore.edu.in/wp-content/uploads/2020/10/lingesh.jpg'
            Name='Dr. B. V. Lingesh'
            Designation='Mechanical Engineering'
            />
            <Slide 
                Source='https://bit-bangalore.edu.in/wp-content/uploads/2020/10/smitha.jpg'
            Name='Prof. A. N. Smitha'
            Designation='Electrical & Electronics Engineering'
            />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            </Slider>
            </div>
            <div>
            <br></br>
            <h1>Support Staff</h1>
            <br></br>
            <Slider {...settings}>
            <Slide 
                Source='https://bit-bangalore.edu.in/wp-content/uploads/2020/10/dharma.jpg'
                Name='H. M. Dharmapale Gowda'
                Designation='Mechanic'
            />
            <Slide />
            <Slide />
            
            </Slider>
            </div>
            </div>
            </div>
           )

          
      

    
}

export {PlacementProcess, PlacementStatistics, OurRecruiters, ActivitiesFacilities, PlacementTeam}
